import React from 'react';
import { NewButton } from 'components/Button/NewButton/NewButton';
import { Icon, IconName } from 'components/Icon/Icon';
import Text from 'components/Text/Text';

type TTypeOfInfoIcon = 'toDelete' | 'toArchive' | 'toRestore' | 'toSave';

const infoIcons: Record<TTypeOfInfoIcon, IconName> = {
	toDelete: IconName.deleteLarge,
	toArchive: IconName.archiveLarge,
	toRestore: IconName.restoreLarge,
	toSave: IconName.saveLarge,
};

interface IProps {
	onConsentEvent: () => void;
	onFailureEvent: () => void;
	description: string;
	additionalDescription?: string;
	typeOfInfoIcon: TTypeOfInfoIcon;
}

export const ModalToConfirmNew: React.FC<IProps> = ({
	onConsentEvent,
	onFailureEvent,
	description,
	additionalDescription,
	typeOfInfoIcon,
}) => {
	const isDelete = typeOfInfoIcon === 'toDelete';
	const isSave = typeOfInfoIcon === 'toSave';

	return (
		<div className="absolute inset-0 flex items-center justify-center" data-test="ModalToConfirmIsVisible">
			<div className="w-full max-w-120 p-8 rounded flex flex-col items-center gap-6 bg-white-00-new shadow-500">
				<Icon
					name={infoIcons[typeOfInfoIcon]}
					size="hero"
					className={isDelete ? 'text-red-03-new' : 'text-purple-03-new'}
				/>
				<div className="w-full flex flex-col items-center gap-4">
					<Text
						translationNameSpace="modals"
						translationKey={description}
						size="xl"
						weight="bold"
						align="center"
					/>
					{additionalDescription && (
						<Text
							translationNameSpace="modals"
							translationKey={additionalDescription}
							size="m"
							align="center"
						/>
					)}
				</div>
				<div className="flex gap-4">
					<NewButton variant="outline" color="gray" size="small" testId="noButton" onClick={onFailureEvent}>
						<Text
							translationNameSpace="modals"
							translationKey={isSave ? 'noButton' : 'cancelButton'}
							asFragment={true}
						/>
					</NewButton>
					<NewButton
						variant="primary"
						color={isDelete ? 'red' : 'purple'}
						size="small"
						type="submit"
						testId="yesButton"
						onClick={onConsentEvent}>
						<Text
							translationNameSpace="modals"
							translationKey={isDelete ? 'removeButton' : 'yesButton'}
							asFragment={true}
						/>
					</NewButton>
				</div>
			</div>
		</div>
	);
};
